import {
  useCheckPermissionOR,
  useCheckPermissions,
} from 'hooks/useCheckPermissions';

import {
  ABILITY_ACTION,
  ABILITY_SUBJECT,
  MANAGE_MEMBER_BILLING_PERMISSION,
  MANAGE_MEMBER_CREDIT_CARD_PERMISSION,
} from 'static/Permission';
import { useCheckEditMemberCreditCardPermission } from 'pages/company-profile/components/tabs/billing/hooks';

export const useCheckCreditCardPermission = () => {
  const checkPermissionOr = useCheckPermissionOR();
  const isMemberBillingManagement = useCheckPermissions(
    MANAGE_MEMBER_BILLING_PERMISSION
  );

  const isEditMember = useCheckEditMemberCreditCardPermission();

  const canAccessBilling = checkPermissionOr([
    [ABILITY_ACTION.MANAGE, ABILITY_SUBJECT.ALL],
    [ABILITY_ACTION.PAY, ABILITY_SUBJECT.MEMBER_CREDIT_CARD],
    [ABILITY_ACTION.MAINTAIN, ABILITY_SUBJECT.MEMBER_CREDIT_CARD],
    [ABILITY_ACTION.MAINTAIN, ABILITY_SUBJECT.MEMBER_BILLING_MANAGEMENT],
    [ABILITY_ACTION.DELETE, ABILITY_SUBJECT.MEMBER_CREDIT_CARD],
    [ABILITY_ACTION.VIEW, ABILITY_SUBJECT.MEMBER_BILLING],
  ]);

  const isManageMemberBilling = useCheckPermissions(
    MANAGE_MEMBER_BILLING_PERMISSION
  );

  const canEditPayment = isEditMember && isManageMemberBilling;

  const isManageMemberCreditCard = useCheckPermissions(
    MANAGE_MEMBER_CREDIT_CARD_PERMISSION
  );

  const isEditAndManageMemberCreditCard =
    isEditMember && isManageMemberCreditCard;

  const canActionCard = canEditPayment || isEditAndManageMemberCreditCard;

  const canPayViaCreditCard = checkPermissionOr([
    [ABILITY_ACTION.PAY, ABILITY_SUBJECT.MEMBER_CREDIT_CARD],
  ]);

  const canViewSavedCard = checkPermissionOr([
    [ABILITY_ACTION.MAINTAIN, ABILITY_SUBJECT.MEMBER_CREDIT_CARD],
    [ABILITY_ACTION.PAY, ABILITY_SUBJECT.MEMBER_CREDIT_CARD],
    [ABILITY_ACTION.MAINTAIN, ABILITY_SUBJECT.MEMBER_BILLING_MANAGEMENT],
    [ABILITY_ACTION.VIEW, ABILITY_SUBJECT.MEMBER_BILLING],
  ]);

  const canAddCharge = isMemberBillingManagement && isEditMember;

  const hasDeleteCardPermission = useCheckPermissions([
    [ABILITY_ACTION.DELETE, ABILITY_SUBJECT.MEMBER_CREDIT_CARD],
  ]);

  return {
    canAccessBilling,
    canActionCard: canActionCard,
    canEditPayment: canEditPayment,
    canPayViaCreditCard,
    canAddCharge,
    canViewSavedCard,
    hasDeleteCardPermission,
  };
};
